'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ValueSet2 = require('../ValueSet');

var _ValueSet3 = _interopRequireDefault(_ValueSet2);

var _cardinality = require('../cardinality');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ValueSetRegistry = require('../ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSourceValueList = function (_ValueSet) {
    (0, _inherits3.default)(DataSourceValueList, _ValueSet);

    function DataSourceValueList() {
        (0, _classCallCheck3.default)(this, DataSourceValueList);
        return (0, _possibleConstructorReturn3.default)(this, (DataSourceValueList.__proto__ || (0, _getPrototypeOf2.default)(DataSourceValueList)).apply(this, arguments));
    }

    (0, _createClass3.default)(DataSourceValueList, [{
        key: 'toQueryFragment',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(appContext) {
                var dataItems;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_lodash2.default.hasIn(appContext, 'DataSourceQuery.requestDataSourceItems')) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return', _promise2.default.reject(new Error('appContext does not support requestDataSourceItems')));

                            case 2:
                                _context.next = 4;
                                return appContext.DataSourceQuery.requestDataSourceItems(this.dataSourceId);

                            case 4:
                                dataItems = _context.sent;
                                return _context.abrupt('return', _lodash2.default.map(dataItems, 'value'));

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function toQueryFragment(_x) {
                return _ref.apply(this, arguments);
            }

            return toQueryFragment;
        }()
    }, {
        key: 'dataSourceId',
        get: function get() {
            return this.data.dataSourceId;
        },
        set: function set(value) {
            this.data.dataSourceId = value;
        }
    }]);
    return DataSourceValueList;
}(_ValueSet3.default);

DataSourceValueList.defaultData = {
    dataSourceId: null
};
DataSourceValueList.displayName = 'Data Source Value List';
DataSourceValueList.cardinality = _cardinality.cardinalityMany;
DataSourceValueList.hasDataType = true;
DataSourceValueList.dataset = false;

_ValueSetRegistry2.default.register(DataSourceValueList);
exports.default = DataSourceValueList;